import * as React from 'react';
import { useTranslation } from 'hooks';

import { optionsMapper, multiSelectorOptionsMapper } from './utils';

type Option = {
  label: string;
  value: string;
}

const translations = {
  yes: {
    pt: 'Sim',
    en: 'Yes',
    es: 'Sí',
    de: 'Ja',
  },
  no: {
    pt: 'Não',
    en: 'No',
    es: 'No',
    de: 'Nein',
  },
};

export const useYesOrNoOptions = () => {
  const { getTranslation: t } = useTranslation(translations);

  const options = React.useMemo((): Option[] => {
    return [
      { value: '1', label: t('yes') },
      { value: '0', label: t('no') },
    ];
  }, [t]);

  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
};